var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.isLoading)?_c('div',{attrs:{"id":"loading-overlay"}},[_vm._v("\n  "+_vm._s(_vm.loadingLabel)+" ...\n  "),_c('br'),_c('img',{staticStyle:{"width":"40px","margin-top":"20px"},attrs:{"src":"/loading/loading.svg"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }